// extracted by mini-css-extract-plugin
export default {"bar":"progress-bar_bar__+Qyr7","scale":"progress-bar_scale__aD1Ja"};